import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=6ca5d88a&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=ts&"
export * from "./CardItem.vue?vue&type=script&lang=ts&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=6ca5d88a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5d88a",
  null
  
)

export default component.exports